import React from 'react'
import classnames from 'classnames/bind'
import CoverImage from 'components/shared/CoverImage'
import Ratio from 'components/shared/Ratio'
import DefaultCover from '../DefaultCover'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const CardCover = ({ className, image, featured }) => {
  const classNames = cx(css.CardCover, className, { featured })
  
return (
  <Ratio ratio={198 / 380} className={classNames}>
    {image ? <CoverImage media {...image} /> : <DefaultCover />}
  </Ratio>
  )
}

export default CardCover
